export const installmentsTypes = {
  first: { name: "First Installment", hi: "पहली किस्त", value: "1" },
  second: { name: "Second Installment", hi: "दूसरी किस्त", value: "2" },
  third: { name: "Third Installment", hi: "तीसरी किस्त", value: "3" },
  stampDuty: { name: "Stamp Duty", hi: "स्टाम्प शुल्क", value: "4" },
};

export const installmentsList = Object.values(installmentsTypes);

export const schemeTypes = {
  sreimbursementcapitalincentive: {
    value: "1",
    label: "Capital Subsidy/Stamp Duty Reimbursement",
    installments: [
      installmentsList.first,
      installmentsList.second,
      installmentsList.stampDuty,
    ],
    installmentStages: 2,
    showStampDuty: true,
  },
  interestassistance: {
    value: "2",
    label: "Interest Assistance",
    installments: [
      installmentsList.first,
      installmentsList.second,
      installmentsList.third,
    ],
    installmentStages: 3,
    showStampDuty: false,
  },
};

export const schemeTypesList = Object.values(schemeTypes);

export const yojanaOptions = [
  {
    id: "prayatanuddamiprotsahanyojna",
    label: "Uttarakhand Paryatan Udhyami Protsahan Yojana",
    label_hi: "उत्तराखंड पर्यटन उद्यमी प्रोत्साहन योजना",
  },
  {
    id: "uttarakhandtourismpolicy2023",
    label: "Uttarakhand Tourism Policy 2023",
    label_hi: "उत्तराखंड पर्यटन नीति 2023",
  },
];

export const yojanaDropdownOptions = yojanaOptions.map((yojana) => ({
  value: yojana.id,
  label: yojana.label,
}));
